export const TopNavbar = ({ Link, auth }) => {
  return (
    <div className="topbar topbar-dark">
      <div className="container-fluid">
        {/* <div className="topHeader">
          <div className="topbar__item">
            <Link to="/" className="topbar__item--link">
              User Guide
            </Link>
          </div>
          <div className="topbar__item">
            <Link to="/" className="topbar__item--link">
              Video Tutorial
            </Link>
          </div>
          <div className="topbar__item">
            <Link to="/" className="topbar__item--link">
              FAQ
            </Link>
          </div>
          <div className="topbar__item">
            <Link to="/" className="topbar__item--link">
              Contact Us
            </Link>
          </div>
        </div> */}
      </div>
    </div>
  );
};
